module.exports = __webpack_public_path__ + "img/zx.237bcb3a.png";